import { WHY_FEATURES } from "@/data/content";
import Icon from "@/components/Icon";

// Left column = first 3, Right column = last 3. Row order: top, mid, bottom.
const LEFT = [
  { ...WHY_FEATURES[0], pos: "l1", color: "blue" },
  { ...WHY_FEATURES[1], pos: "l2", color: "teal" },
  { ...WHY_FEATURES[2], pos: "l3", color: "blue" },
];
const RIGHT = [
  { ...WHY_FEATURES[3], pos: "r1", color: "blue" },
  { ...WHY_FEATURES[4], pos: "r2", color: "teal" },
  { ...WHY_FEATURES[5], pos: "r3", color: "blue" },
];

const BLUE = "#2f80e0";
const TEAL = "#25b6a4";

function Pod({ f, side }) {
  return (
    <div className={`why2__pod why2__pod--${f.pos} ${side === "right" ? "why2__pod--right" : ""}`} data-testid={`why-item-${f.title}`}>
      <div className="why2__pod-inner">
        <span className="why2__pod-ic"><Icon name={f.icon} size={26} strokeWidth={1.8} /></span>
        <div className="why2__pod-txt">
          <h3 className="why2__pod-title">{f.title}</h3>
          <p className="why2__pod-text">{f.text}</p>
        </div>
      </div>
    </div>
  );
}

export default function WhySection() {
  return (
    <section className="section why2" id="why" data-testid="why-section">
      <div className="container">
        <div className="why2__head">
          <h2 className="why2__title">Why Proactive UMS Corporate?</h2>
          <span className="why2__rule" />
          <p className="why2__sub">We bring together people, technology and healthcare operations to create a more connected, efficient and compassionate future.</p>
        </div>

        <div className="why2__stage">
          {/* Connector layer */}
          <svg className="why2__svg" viewBox="0 0 1180 600" fill="none" aria-hidden="true">
            <g strokeWidth="2.5" strokeLinecap="round">
              {/* left connectors */}
              <path d="M483,210 Q430,150 372,132" stroke={BLUE} strokeDasharray="1 9" />
              <path d="M450,300 Q412,300 372,300" stroke={TEAL} strokeDasharray="1 9" />
              <path d="M483,390 Q430,450 372,468" stroke={BLUE} strokeDasharray="1 9" />
              {/* right connectors */}
              <path d="M697,210 Q750,150 808,132" stroke={BLUE} strokeDasharray="1 9" />
              <path d="M730,300 Q768,300 808,300" stroke={TEAL} strokeDasharray="1 9" />
              <path d="M697,390 Q750,450 808,468" stroke={BLUE} strokeDasharray="1 9" />
            </g>
            {/* circle nodes (white ring + colored center) */}
            {[
              [483, 210, BLUE], [450, 300, TEAL], [483, 390, BLUE],
              [697, 210, BLUE], [730, 300, TEAL], [697, 390, BLUE],
            ].map(([x, y, c], i) => (
              <g key={`n${i}`}>
                <circle cx={x} cy={y} r="9" fill="#ffffff" />
                <circle cx={x} cy={y} r="4" fill={c} />
              </g>
            ))}
            {/* pod-end dots */}
            {[
              [372, 132, BLUE], [372, 300, TEAL], [372, 468, BLUE],
              [808, 132, BLUE], [808, 300, TEAL], [808, 468, BLUE],
            ].map(([x, y, c], i) => (
              <circle key={`d${i}`} cx={x} cy={y} r="6" fill={c} />
            ))}
          </svg>

          {/* Center hub */}
          <div className="why2__center" data-testid="why-center">
            <div className="why2__center-disc">
              <span className="why2__center-ic"><Icon name="Users" size={40} strokeWidth={1.6} /></span>
              <div className="why2__center-lines">People<br />Technology<br />Healthcare<br />Operations</div>
              <span className="why2__center-div" />
              <div className="why2__center-cap">A MORE CONNECTED<br />HEALTHIER TOMORROW</div>
            </div>
          </div>

          {/* Pods */}
          {LEFT.map((f) => <Pod key={f.title} f={f} side="left" />)}
          {RIGHT.map((f) => <Pod key={f.title} f={f} side="right" />)}
        </div>
      </div>
    </section>
  );
}
